module.exports = __webpack_public_path__ + "static/media/customerServiceimg1.f9e77578.png";